// extracted by css-extract-rspack-plugin
export default {"shimmerText":"Tbwz1t_VAgI9YD1w","shimmer":"ViyJbHBLkoPC1xOg","shimmerPaused":"wupJO1chjK4eltbN","staticText":"FGRUpQVrDkntV1Z7"};